export const mutipleMarketManage = [
  //商场批量管理页面
  {
    //我的商场
    path: 'multiple_market',
    name: 'multipleMarket',
    component: () => import('@/page/main/market/multiple/index'),
    meta: {
      router: [
        { title: '首页', path: '/main/home' },
        { title: '我的商场批量维护', path: '/main/multiple_market' },
      ],
    },
  },
  {
    //我的部门
    path: 'department_multiple_market',
    name: 'departmentMultipleMarket',
    component: () => import('@/page/main/market/multiple/index'),
    meta: {
      router: [
        { title: '首页', path: '/main/home' },
        { title: '我的部门批量维护', path: '/main/department_multiple_market' },
      ],
    },
  },
  {
    //全部商场
    path: 'all_multiple_market',
    name: 'allMultipleMarket',
    component: () => import('@/page/main/market/multiple/index'),
    meta: {
      router: [
        { title: '首页', path: '/main/home' },
        { title: '全部商场批量维护', path: '/main/all_multiple_market' },
      ],
    },
  },
  {
    //集团商场
    path: 'oppein_multiple_market',
    name: 'oppeinMultipleMarket',
    component: () => import('@/page/main/market/multiple/index'),
    meta: {
      router: [
        { title: '首页', path: '/main/home' },
        { title: '集团商场批量维护', path: '/main/oppein_multiple_market' },
      ],
      single: false,
    },
  },
  {
    //集团商场
    path: 'oppein_multiple_market_right',
    name: 'oppeinMultipleMarketRight',
    component: () => import('@/page/main/market/multiple/index'),
    meta: {
      router: [
        { title: '商场经营权列表', path: '/main/oppein_multiple_market_right' },
      ],
      single: true,
      type: 'marketRight',
    },
  },
]
export const marketManage = [
  //商场管理相关
  {
    //我的商场
    path: 'market',
    name: 'marketDetailCheck',
    component: () => import('@/page/main/market/table/index'),
    meta: {
      router: [
        { title: '首页', path: '/main/home' },
        { title: '我的商场', path: '/main/market' },
      ],
    },
  },
  {
    //我的部门
    path: 'department_market',
    name: 'departmentMarket',
    component: () => import('@/page/main/market/table/index'),
    meta: {
      router: [
        { title: '首页', path: '/main/home' },
        { title: '我的部门', path: '/main/department_market' },
      ],
    },
  },
  {
    //全部商场
    path: 'all_market',
    name: 'allMarket',
    component: () => import('@/page/main/market/table/index'),
    meta: {
      router: [
        { title: '首页', path: '/main/home' },
        { title: '全部商场', path: '/main/all_market' },
      ],
    },
  },
  {
    //集团商场
    path: 'oppein_market',
    name: 'oppeinMarket',
    component: () => import('@/page/main/market/table/index'),
    meta: {
      router: [
        { title: '首页', path: '/main/home' },
        { title: '集团商场', path: '/main/oppein_market' },
      ],
    },
  },
  {
    //新增商场管理界面
    name: 'creatMarket',
    path: 'market/creatMarket',
    component: () => import('@/page/main/market/add/index'),
    meta: {
      router: [
        { title: '首页', path: '/main/home' },
        { title: '商场管理', path: '/main/market' },
      ],
    },
  },
  {
    //新增商场管理界面 - ASSP 招商管理待办任务跳转
    name: 'creatMarketTodo',
    path: 'market/creatMarketTodo',
    component: () => import('@/page/main/market/add/todo.vue'),
    meta: {
      router: [
        { title: '首页', path: '/main/home' },
        { title: '商场管理', path: '/main/market' },
      ],
    },
  },
  {
    //新增商场提交页面
    name: 'changeMarket',
    path: 'market/changeMarket',
    component: () => import('@/page/main/market/edit/index'),
    meta: {
      router: [
        { title: '首页', path: '/main/home' },
        { title: '商场管理', path: '/main/market' },
      ],
    },
  },
]
export const managementRightsManage = [
  //经营权管理
  {
    path: 'management_right_area',
    name: 'managementRightArea',
    component: () => import('@/page/main/management-rights/area/index'),
    meta: {
      keepAlive: true,
      router: [
        { title: '首页', path: '/main/home' },
        { title: '经营区域列表', path: '/main/management_right_area' },
      ],
    },
  },
  {
    path: 'management_right_area_add',
    name: 'addManagementRightArea',
    component: () => import('@/page/main/management-rights/area/edit'),
    meta: {
      router: [
        { title: '首页', path: '/main/home' },
        {
          title: '新增经营区域',
          path: '/main/management_right_area_add',
        },
      ],
    },
  },
  {
    path: 'management_right_area_edit',
    name: 'editManagementRightArea',
    component: () => import('@/page/main/management-rights/area/edit'),
    meta: {
      router: [
        { title: '首页', path: '/main/home' },
        {
          title: '修改经营区域',
          path: '/main/management_right_area_edit',
        },
      ],
    },
  },
  {
    path: 'business_line_extend',
    name: 'businessLineExtend',
    component: () => import('@/page/main/management-rights/business-line-extend/index'),
    meta: {
      keepAlive: true,
      router: [
        { title: '首页', path: '/main/home' },
        { title: '事业线经营范围列表', path: '/main/business_line_extend' },
      ],
    },
  },
  {
    path: 'business_line_extend_add',
    name: 'addBusinessLineExtend',
    component: () => import('@/page/main/management-rights/business-line-extend/edit'),
    meta: {
      router: [
        { title: '首页', path: '/main/home' },
        {
          title: '新增事业线经营范围',
          path: '/main/business_line_extend_add',
        },
      ],
    },
  },
  {
    path: 'business_line_extend_edit',
    name: 'editBusinessLineExtend',
    component: () => import('@/page/main/management-rights/business-line-extend/edit'),
    meta: {
      router: [
        { title: '首页', path: '/main/home' },
        {
          title: '修改事业线经营范围',
          path: '/main/business_line_extend_edit',
        },
      ],
    },
  },
  {
    path: 'business_line_right',
    name: 'businessLineRight',
    component: () => import('@/page/main/management-rights/business-line-management-right/index'),
    meta: {
      keepAlive: true,
      router: [
        { title: '首页', path: '/main/home' },
        { title: '事业线经营权列表', path: '/main/business_line_right' },
      ],
    },
  },
  {
    path: 'business_line_right_edit',
    name: 'editBusinessLineRight',
    component: () => import('@/page/main/management-rights/business-line-management-right/edit'),
    meta: {
      router: [
        { title: '首页', path: '/main/home' },
        {
          title: '事业线经营权(新增/修改)',
          path: '/main/business_line_right_edit',
        },
      ],
    },
  },
  {
    path: 'business_line_right_audit',
    name: 'auditBusinessLineRight',
    component: () => import('@/page/main/management-rights/audit/index'),
    meta: {
      router: [
        { title: '首页', path: '/main/home' },
        {
          title: '经营权审批列表',
          path: '/main/business_line_right_audit',
        },
      ],
    },
  },
  {
    path: 'business_right_transfer',
    name: 'businessRightTransfer',
    component: () => import('@/page/main/management-rights/transfer/index'),
    meta: {
      router: [
        { title: '首页', path: '/main/home' },
        {
          title: '经营权数据转移列表',
          path: '/main/business_right_transfer',
        },
      ],
    },
  },
  {
    path: 'apply_commission_apply',
    name: 'applyCommissionApply',
    component: () => import('@/page/main/applyCommission/apply'),
    meta: {
      router: [
        { title: '首页', path: '/main/home' },
        {
          title: '代销申请审核列表',
          path: '/main/apply_commission_apply',
        },
      ],
    },
  },
  {
    path: 'apply_commission_accredit',
    name: 'applyCommissionAccredit',
    component: () => import('@/page/main/applyCommission/accredit'),
    meta: {
      router: [
        { title: '首页', path: '/main/home' },
        {
          title: '代销申请审核列表(授权)',
          path: '/main/apply_commission_accredit',
        },
      ],
    },
  },
]

export const ExternalMarketManager = [
  {
    path: '/external/marketDetail',
    name: 'externalMarketDetail',
    component: () => import('@/page/main/market/edit/external/market-detail'),
    meta: {
      keepAlive: false,
      white: true,
    },
  },
]
